import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube, Twitter, Mail, Phone, MapPin } from "lucide-react";
import { toast } from "sonner";

export default function Footer() {
  const submit = (e) => { e.preventDefault(); toast.success("Subscribed to Batra Electronics insider list"); e.target.reset(); };
  return (
    <footer className="mt-24 on-dark" style={{ background: "#0A0A0A", color: "#EDEDED" }} data-testid="site-footer">
      <div className="container-x py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2 space-y-5">
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 rounded-full border-2 flex items-center justify-center" style={{ borderColor: "#C99A2A" }}>
                <div className="w-2 h-2 rounded-full" style={{ background: "#C99A2A" }}></div>
              </div>
              <div className="leading-tight">
                <span className="font-display text-lg tracking-[0.18em] font-extrabold text-white">BATRA ELECTRONICS</span>
                <div className="text-[10px] uppercase tracking-[0.28em]" style={{ color: "#C99A2A" }}>Cinema · Audio · Dehradun</div>
              </div>
            </div>
            <p className="text-white/70 text-sm max-w-md leading-relaxed">
              Authorised distributor of premium home theatre and hi-fi audio brands — Klipsch, KEF, Marantz, SVS and more. Designing reference-grade cinemas from Dehradun since 1985.
            </p>
            <form onSubmit={submit} className="flex gap-2 max-w-md" data-testid="newsletter-form">
              <input required type="email" placeholder="Your email" data-testid="newsletter-email" className="flex-1" />
              <button type="submit" className="btn-gold text-xs px-5 py-3" data-testid="newsletter-submit">Subscribe</button>
            </form>
            <div className="flex gap-3 pt-2">
              {[Instagram, Facebook, Youtube, Twitter].map((I, i) => (
                <a key={i} href="#" className="w-10 h-10 rounded-full flex items-center justify-center transition hover:text-white" style={{ border: "1px solid rgba(255,255,255,0.14)", color: "rgba(255,255,255,0.7)" }} data-testid={`social-${i}`}>
                  <I className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>
          <div>
            <div className="kicker mb-4">Shop</div>
            <ul className="space-y-2.5 text-sm text-white/70">
              <li><Link to="/shop" className="hover:text-white">All Products</Link></li>
              <li><Link to="/packages" className="hover:text-white">Home Theatre Packages</Link></li>
              <li><Link to="/shop/Tower%20Speakers" className="hover:text-white">Tower Speakers</Link></li>
              <li><Link to="/shop/AV%20Receivers" className="hover:text-white">AV Receivers</Link></li>
              <li><Link to="/shop/Subwoofers" className="hover:text-white">Subwoofers</Link></li>
              <li><Link to="/shop/Projectors" className="hover:text-white">Projectors</Link></li>
            </ul>
          </div>
          <div>
            <div className="kicker mb-4">Company</div>
            <ul className="space-y-2.5 text-sm text-white/70">
              <li><Link to="/about" className="hover:text-white">About</Link></li>
              <li><Link to="/installation" className="hover:text-white">Installation Services</Link></li>
              <li><Link to="/brands" className="hover:text-white">Premium Brands</Link></li>
              <li><Link to="/quote" className="hover:text-white">Get a Quote</Link></li>
              <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
            </ul>
          </div>
          <div>
            <div className="kicker mb-4">Reach Us</div>
            <ul className="space-y-3 text-sm text-white/70">
              <li className="flex gap-2"><MapPin className="w-4 h-4 mt-0.5 shrink-0" style={{ color: "#C99A2A" }} /> Batra Electronics, 55 Dispensary Road, Dehradun, Uttarakhand 248001</li>
              <li className="flex gap-2"><Phone className="w-4 h-4 mt-0.5 shrink-0" style={{ color: "#C99A2A" }} /> <a href="tel:+918018911999" className="hover:text-white">+91 80189 11999</a></li>
              <li className="flex gap-2"><Mail className="w-4 h-4 mt-0.5 shrink-0" style={{ color: "#C99A2A" }} /> <a href="mailto:batraelectronics55@gmail.com" className="hover:text-white break-all">batraelectronics55@gmail.com</a></li>
            </ul>
          </div>
        </div>
        <div className="my-10" style={{ height: 1, background: "rgba(255,255,255,0.10)" }}></div>
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-white/50">
          <p>© {new Date().getFullYear()} Batra Electronics · Dehradun. All rights reserved.</p>
          <div className="flex gap-6">
            <a href="#" className="hover:text-white">Privacy</a>
            <a href="#" className="hover:text-white">Terms</a>
            <Link to="/return-policy" className="hover:text-white">Return Policy</Link>
            <Link to="/consultation" className="hover:text-white">Consultation</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
